import axios, { AxiosRequestConfig, AxiosResponse, InternalAxiosRequestConfig } from "axios";
import customStorage from "./storage";
import { COMPANY_SETTINGS, GLOBAL_KEYS } from "@/configs";
import { getCookieValue, getTimeZoneWithGMT, getUrlParamValue } from "./index";
import { Message } from "@/components/basic";
import { router } from "@/configs/routes";
import { exchangeRequestApiConfig } from "./enhance-request";

export type RequestOptions = AxiosRequestConfig & {
  /** 是否附带现有 App Token，OAuth 登录与授权使用独立凭证时设为 false。 */
  withAppToken?: boolean;
  /** 是否由当前页面展示错误与重试，设为 true 时跳过全局提示和错误页跳转。 */
  handleErrorLocally?: boolean;
};

type CustomConfig = InternalAxiosRequestConfig & Pick<RequestOptions, "withAppToken" | "handleErrorLocally">;

// 假设从localStorage或某个全局状态管理库中获取token
function getToken() {
  const token = getCookieValue("token") || localStorage.getItem("token") || null;
  return token;
}

// 创建axios实例
const request = axios.create({
  baseURL: process.env.REACT_APP_BASE_API, // api的base_url
  timeout: 3600000, // 请求超时时间
  headers: {
    "Content-Type": "application/json;charset=UTF-8",
    "Request-Source": "Web-Backend",
    "Time-Zone": getTimeZoneWithGMT(),
  },
});

// let isIntercept = false;

// 请求拦截器
request.interceptors.request.use(
  (config: CustomConfig) => {
    // console.log("🚀 ~ config:", config);
    // 在发送请求之前做些什么
    // if (config.headers["Content-Type"] !== "application/json") {
    //   config.headers["Content-Type"] = "application/json;charset=UTF-8";
    // }
    //安全请求header
    // config.headers["Blade-Requested-With"] = "BladeHttpRequest";
    //headers判断是否需要
    // config.headers["Authorization"] = `Basic ${Base64.encode(`${GLOBAL_CONFIGS.clientId}:${GLOBAL_CONFIGS.clientSecret}`)}`;
    // 添加token到headers
    // 默认沿用 App 登录态；独立 OAuth 流程仅发送自身所需的登录凭证。
    if (config.withAppToken ?? true) {
      config.headers["Authorization"] = getToken();
    }
    config.headers["Accept-Language"] = getUrlParamValue(location.href, "lang") || localStorage.getItem("lang");
    // config.headers["Accept-Language"] = 'en-US';
    // if (config?.params?.withAuth ?? true) {
    //   if (token) {
    //     config.headers[GLOBAL_CONFIGS.tokenHeader] = `crypto ${crypto.encryptAES(token, crypto.cryptoKey)}`;
    //     config.headers["Blade-Auth"] = `Bearer ${token}`;
    //   } else {
    //     // console.log("🚀 ~ token:", token);
    //     if (!isIntercept) {
    //       isIntercept = true;
    //       Message.warning("未登录或令牌已过期");
    //       history.replace("/login");
    //     }else{
    //       isIntercept = false;
    //     }
    //     return Promise.reject("未登录或令牌已过期");
    //   }
    //   delete config?.params?.withAuth;
    // }
    config.headers["Tenant-Id"] = COMPANY_SETTINGS.tenantId;
    // config.headers["Dept-Id"] = GLOBAL_CONFIGS.tenantId;
    // config.headers["Role-Id"] = GLOBAL_CONFIGS.tenantId;
    // if (config.data) {
    //   config.data["tenantId"] = GLOBAL_CONFIGS.tenantId;
    // }
    // if (config.params) {
    //   config.params["tenantId"] = GLOBAL_CONFIGS.tenantId;
    // }
    return exchangeRequestApiConfig(config);
  },
  (error) => {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

// 响应拦截器
request.interceptors.response.use(
  (response: AxiosResponse) => {
    // 对响应数据做点什么
    const { data } = response;
    if (Object.prototype.hasOwnProperty.call(data, "success")) {
      if (data.success) {
        return response.data;
      } else {
        if (!(response.config as CustomConfig).handleErrorLocally) {
          Message.info(data?.error_description || data?.msg || "请求失败");
        }
        throw new Error(data?.error_description || data?.msg || "请求失败");
      }
    } else {
      return response.data;
    }
  },
  (error) => {
    // 登录授权表单自行处理网络错误，保持当前输入和授权状态以便重试。
    if ((error.config as CustomConfig)?.handleErrorLocally) return Promise.reject(error);
    // 对响应错误做点什么
    const { response } = error;
    if (response && response.status) {
      // 根据状态码进行不同的错误处理
      switch (response.status) {
        case 401:
          // 未授权，跳转登录页
          customStorage.removeItem(GLOBAL_KEYS.USER_TOKEN);
          // Message.info("请先登录！");

          // router.navigate("/login");
          break;
        case 403:
          Message.info("Access denied");
          break;
        case 404:
          Message.info("Api does not exist.");
          break;
        case 500:
        case 502:
          router.navigate("/500");
          break;
        // 可以添加更多状态码的处理
        default:
          Message.info(`request error: ${response?.message || response?.data?.msg}`);
      }
    } else if (error.message === "Network Error") {
      // Message.info("网络连接失败，请检查网络后重试");
      router.navigate("/500");
    } else if (error.message) {
      // 处理请求错误
      //   message.error(error.message);
    }
    return Promise.reject(error);
  }
);

export default request;
